import { Tabs, Tab } from '@mui/material';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)`
  width: 100%;
  margin-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[300]};
`;

export const StyledTab = styled(Tab)`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.4px;
  text-transform: capitalize;
  min-height: initial;
`;

export const Container = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const OptionContainer = styled(Link)`
  align-items: center;
  display: flex;
  padding: 9px 16px;
  padding-bottom: 0;
  flex-direction: column;
  justify-content: space-between;
  text-decoration: none;
`;

export const IconContainer = styled.div`
  margin-right: 8px;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const OptionLine = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

export const Line = styled.hr`
  margin: 0;
  margin-top: 8px;
  margin-bottom: -1px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  width: 100%;
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
`;

export const OptionLabel = styled.p<{ $active: boolean }>`
  margin: 0;
  color: ${({ $active, theme }) => ($active ? theme.palette.primary.main : theme.palette.text.secondary)};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.4px;
`;
